module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n';
 _.each(classes, function(klass, class_i) { 
__p+='\n	';
 if ( filterClass && klass.name !== filterClass ) return; 
__p+='\n\n	<h2>'+
((__t=( klass.name ))==null?'':__t)+
'</h2>\n\n	<table class="reserva-table-year" cellspacing="0" cellpadding="0">\n		<thead>\n			<tr>\n				<th>&nbsp;</th>\n				';
 for(var j = 1; j <= 31; ++j) { 
__p+='\n				<th>'+
((__t=( j ))==null?'':__t)+
'</th>\n				';
 } 
__p+='\n			</tr>\n		</thead>\n		<tbody>\n			';
 var daysOffset = 0 
__p+='\n			';
 var end = false 
__p+='\n			';
 var year = (new Date()).getFullYear(); 
__p+='\n\n			<!-- Cycle through each possible month, up to 4 years -->\n			';
 for(var monthIndex = start.month(); monthIndex < 48; ++monthIndex) { if ( end ) break; 
__p+='\n				\n				<!-- Break on next year -->\n				';
 if ( monthIndex % 12 == 0 && monthIndex != 0 ) { 
__p+='\n					';
 year++ 
__p+='\n					<tr class="break"><td colspan="32"></td></tr>\n				';
 } 
__p+='\n\n				<tr>\n					<!-- Left header -->\n					<th>\n						'+
((__t=( monthNames[monthIndex % 12] ))==null?'':__t)+
'\n						'+
((__t=( (year + "").substring(2) ))==null?'':__t)+
'\n					</th>\n\n					<!-- Fill every day of each month -->\n					';
 for(var monthDayIndex = 0; monthDayIndex < monthDays[monthIndex]; ++monthDayIndex) { 
__p+='\n						';
 var day = klass.days[daysOffset]; 
__p+='\n\n						<!-- Offset at the first month -->\n						';
 if ( daysOffset === 0 && monthDayIndex === 0 && start.date() !== 1 ) { 
__p+='\n							<td colspan="'+
((__t=( start.date() - 1 ))==null?'':__t)+
'" class="month-start"></td>\n							';
 monthDayIndex += start.date() - 1 
__p+='\n						';
 } 
__p+='\n\n						';
 if ( day ) { 
__p+='\n\n							<td class="day '+
((__t=( day.className ))==null?'':__t)+
' '+
((__t=( day.helperClasses ))==null?'':__t)+
' cell_'+
((__t=( class_i ))==null?'':__t)+
'_'+
((__t=( day.index ))==null?'':__t)+
'" data-class-offset="'+
((__t=( class_i ))==null?'':__t)+
'" data-day-offset="'+
((__t=( day.index ))==null?'':__t)+
'" data-day="'+
((__t=( day.date.format('LL') ))==null?'':__t)+
'" data-daysOffset="'+
((__t=( daysOffset ))==null?'':__t)+
'">\n								<div></div>\n								';
 if ( day.helperClasses.indexOf("weekend") !== -1 ) { 
__p+='\n									<b></b>\n								';
 } 
__p+='\n								<span></span>\n							</td>\n\n							';
 daysOffset++; 
__p+='\n\n						';
 } else { 
__p+='\n\n							';
 end = true; 
__p+='\n\n							<td class="day rest">\n								<div></div>\n							</td>\n\n						';
 } 
__p+='\n\n					';
 } 
__p+='\n\n					';
 if ( monthDays[monthIndex] < 31 ) { 
__p+='\n						<td colspan="'+
((__t=( 31 - monthDays[monthIndex] ))==null?'':__t)+
'" class="month-rest"></td>\n					';
 } 
__p+='\n\n				</tr>\n			';
 } 
__p+='\n		</tbody>\n	</table>\n\n';
 }) 
__p+='\n';
}
return __p;
};


//////////////////
// WEBPACK FOOTER
// /Users/bm/app/code/jsapps/modules/reserva/templates/miniengine/reserva-yeartable.html
// module id = 77
// module chunks = 0